module.exports = __webpack_public_path__ + "img/sapn_logo.6eb59471.svg";